import { jwtVerify, importSPKI } from 'jose';

const __CUBE_JWT_KEY__ =
    '-----BEGIN PUBLIC KEY-----\nMIICIjANBgkqhkiG9w0BAQEFAAOCAg8AMIICCgKCAgEAkl7tAAXfR7ZtERYVIwvz\nWMg0aKN8Aw7UcrmSfMgpTdwXWsW6mT+G+qBcFUdsry4ve3DulKEtp6y+fCEY2KD/\n9CBXgMppuEkqDp2DTlhQIG8sfQ/4uKsnkASeM9w9Y3YgUf3zl4uwkxmzYa13nUl7\nDkEvm3VSrM47pt1f2WbxMdTxDIL4s8pgkIrKoZnpRy+1pk4P5XxvLF7s71X6lXjh\nhQj9sF9RHO3Zqu8viHOlCgOKG9gVtsnIZ6caxQHy2PYsYd9CPwEIEJHyR9UtSaRs\nCj1GX2+cKjf+hL5On9hOWNStqhKX+KNsZl2lJb5lsRaR36IyekzfSgZJZYC8cg2h\n72wJ4ZgRG9VFpQpwBWeGql+IpLbk2x0jj7I/C3Wp87yXdz3b8Y5/tA66a0wbTabK\n9E2O+CiC1iF9V7zt1fpp7elojoCr4Tiuk5GHI9xT33ikmHjcRBJyU5xgkDz3Ybqg\nhIQm9tbqchjToRI+1qGXm8F2kHR7uUhXEMfAxIPJdL6FU1r4XFdP0ShVvO3BELeh\nxzbAwMkBHH3ThqdRJw1mlxzoktE8L+9ziXdOF6eyUzWcODdUZyEV3QKFOBonDG9m\nS6y5OGlBsOWlbCyHIh4Rrx0e0h+SeHFR4/V67OsrWWAGV+izlPYDFkjtFt6Fr17O\nD3T/cSx1u4p0i1xQztZLhlECAwEAAQ==\n-----END PUBLIC KEY-----';

export type JwtPayload = {
    iat: number;
    exp: number;
    sub: string;
    user: string;
    first_name: string;
    last_name: string;
    roles: string;
    permissions: string;
    permission_ids: string;
    clients: string;
};

export const verifyJwt = async (jwt: string): Promise<JwtPayload> => {
    if (!__CUBE_JWT_KEY__) {
        throw new Error('Failed to retrieve the JWT public key');
    }

    try {
        const publicKey = await importSPKI(__CUBE_JWT_KEY__, 'RS256');
        const { payload } = await jwtVerify(jwt, publicKey, {
            algorithms: ['RS256'],
        });

        return payload as JwtPayload;
    } catch (error) {
        throw new Error('The JWT is invalid');
    }
};

export default verifyJwt;
